<template>
    <ContentOrLoading>
        <div v-if="!loading" class="single-event">
            <PageTitle title="" :style="'background-image: url(&quot;' + event.imagen + '&quot;);'" />

            <CabeceraClubs v-if="event.equipo_local" :event="event" />

            <CabeceraImagen v-else :event="event" />

            <template v-if="event.status == 3">
                <section class="padding-vertical-content">
                    <div class="container">
                        <div class="row align-items-center" style="height: 300px">
                            <div class="col-12 align-items-center">
                                <h1 class="text-center dark-content p-4">{{ $t('eventos.aplazado') }}</h1>
                            </div>
                        </div>
                    </div>
                </section>
            </template>
            <template v-else-if="event.venta_cerrada">
                <section class="padding-vertical-content">
                    <div class="container">
                        <div class="row align-items-center" style="height: 300px">
                            <div class="col-12 align-items-center">
                                <h1 v-if="event.status === 2" class="text-center dark-content p-4">
                                    {{ $t('eventos.cancelado') }}</h1>
                                <h1 v-else-if="event.finalizado" class="text-center dark-content p-4">
                                    {{ $t('eventos.finalizado') }}</h1>
                                <h1 v-else class="text-center dark-content p-4">{{ $t('partidos.proximamente') }}</h1>
                            </div>
                        </div>
                    </div>
                </section>
            </template>
            <template v-else-if="!event.calendario">
                <section class="padding-vertical-content">
                    <div class="container">
                        <ListadoSessiones :event="event" :sesiones="event.sesiones" :productos="false"/>
                    </div>
                </section>
            </template>
            <template v-else-if="event.calendario">
                <section class="padding-vertical-content">
                    <div class="container">
                        <Calendario :event="event"/>
                    </div>
                </section>
            </template>
        </div>
    </ContentOrLoading>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import CabeceraClubs from '@/components/frontend/events/show/CabeceraClubs';
    import CabeceraImagen from '@/components/frontend/events/show/CabeceraImagen';
    import Calendario from '@/components/frontend/events/Calendario';
    import ListadoSessiones from '@/components/frontend/events/ListadoSessiones';

    export default {
        props: ['event_id'],
        data() {
            return {
                loading: false,
                tiempoTerminado: false,
                event: {},
            }
        },
        created() {
            this.getEvent();
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            user() {
                return this.$store.getters.getUser;
            },
            mostrar_header() {
                if (this.$route.name == 'front.home') {
                    return false;
                }
                if (this.$route.name == 'login') {
                    return false;
                }

                return true;
            },
        },
        methods: {
            getEvent() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    event_id: this.event_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.events.show-sesiones'), params).then(res => {
                    this.event = res.data.data;

                    if (this.event.venta_online_cerrada && document.location.href.indexOf('venta_online=test') === -1) {
                        this.$router.push({ name: 'front.eventos.index'});
                    }

                    if (this.event.preventa?.venta_preventa_activa) {
                        if (!this.user || !this.event.preventa?.puede_comprar_en_preventa) {
                            this.$router.push({ name: 'front.eventos.index'});
                        }
                    }
                }).finally(() => this.loading = false);
            },
            volver() {
                this.tiempoTerminado = true;
            },
            recargar() {
                return new Promise(() => {
                    this.refresh = false;
                    this.$nextTick(() => {
                        this.refresh = true;
                    })
                    this.tiempoTerminado = false;
                })
            },
        },
        components: { PageTitle, CabeceraClubs, CabeceraImagen, Calendario, ListadoSessiones }
    }
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}
</style>
